import React, {useState } from "react";
import {
  TableRow,
  TableCell,
  makeStyles,
  Table,
  TableBody,
  TableHead,
  Checkbox,
  IconButton,
  Box,
} from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import moment from "moment";
import { presentFormatedData } from "../../../../functionalComponents/dataFormatFunctions";
import ExceptionDocuments from "./ExceptionDocuments";

const useStyles = makeStyles((theme) => ({
  tableHead: {
    fontWeight: "bold",
    backgroundColor: "#f5f5f5",
  },
  statusClosed: {
    color: "white",
    backgroundColor: "red",
    fontWeight: "bold",
    borderRadius: "0.25rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "4rem",
    height: "2rem",
  },
  statusOpen: {
    color: "white",
    backgroundColor: "green",
    fontWeight: "bold",
    borderRadius: "0.25rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "4rem",
    height: "2rem",
  },
  orangeCheckbox: {
    color: "#F26336",
    "&.Mui-checked": {
      color: "#F26336",
    },
  },
  table: {
    // width: "100%",
    marginBottom: "20px",
  },
  tableCell: {
    borderBottom: "none", // Optional: Remove default bottom borders
    padding: "8px 16px",
    fontSize: "14px", // Adjust the font size if needed
    fontWeight: "500",
  },
  tableHeadCell: {
    borderBottom: "none",
    fontWeight: "bold",
    fontSize: "14px",
    padding: "8px 16px",
    textAlign: "left",
  },
}));
// const exceptionData = {
//   plantID: "8208222",
//   gmpBatchNumber: "1",
//   batchNumber: "DEF-IMCL-184226-DS-001",
//   numberBMR: "BMR-IMCL-184226-DS",
//   batchStartDate: "24-FEB-2024",
//   batchEndDate: "11-MAR-2024",
//   exceptionDetailsList: [
//     {
//       collabrixExceptionID: "3838383",
//       exceptionCreated:
//         "Cleaning and preparation delay of Procedure step 3.1.3.1 and 3.1.3.2",
//       createdDate: "12-AUG-2024",
//       roleAssigned: "Manufacturing Supervisor",
//       userAssigned: "Cliff Mcgee",
//       requireSponsorSMEReview: false,
//       requireSponsorQAReview: false,
//       impactOnProduct: "NO",
//       exceptionSeverity: "LOW",
//       exceptionStatus: "Closed",
//     },
//     {
//       collabrixExceptionID: "4848484",
//       exceptionCreated: "Equipment E-2341 not calibrated before use",
//       createdDate: "14-AUG-2024",
//       roleAssigned: "Manufacturing Supervisor",
//       userAssigned: "Cliff Mcgee",
//       requireSponsorSMEReview: false,
//       requireSponsorQAReview: false,
//       impactOnProduct: "NO",
//       exceptionSeverity: "LOW",
//       exceptionStatus: "Closed",
//     },
//     {
//       collabrixExceptionID: "9293939",
//       exceptionCreated:
//         "High temperatures during Reaction 1, Procedure steps 3.2.4",
//       createdDate: "22-AUG-2024",
//       roleAssigned: "R&D Head",
//       userAssigned: "Cliff Mcgee",
//       requireSponsorSMEReview: true,
//       requireSponsorQAReview: true,
//       impactOnProduct: "YES",
//       exceptionSeverity: "MEDIUM",
//       exceptionStatus: "Open",
//     },
//     {
//       collabrixExceptionID: "7830932",
//       exceptionCreated: "Delayed Warehouse storage, Procedure step 3.7.3.2",
//       createdDate: "28-AUG-2024",
//       roleAssigned: "Warehouse Dept Head",
//       userAssigned: "Jc Archer",
//       requireSponsorSMEReview: false,
//       requireSponsorQAReview: true,
//       impactOnProduct: "YES",
//       exceptionSeverity: "LOW",
//       exceptionStatus: "Open",
//     },
//     {
//       collabrixExceptionID: "4747474",
//       exceptionCreated: "Pump malfunctioned during centrifugation 3.3.2.2",
//       createdDate: "31-AUG-2024",
//       roleAssigned: "R&D Head",
//       userAssigned: "Jc Archer",
//       requireSponsorSMEReview: true,
//       requireSponsorQAReview: false,
//       impactOnProduct: "NO",
//       exceptionSeverity: "LOW",
//       exceptionStatus: "Closed",
//     },
//     {
//       collabrixExceptionID: "7373737",
//       exceptionCreated: "DHS loading pattern not followed, Procedure 3.7.2.1",
//       createdDate: "05-SEP-2024",
//       roleAssigned: "Manufacturing Supervisor",
//       userAssigned: "Cliff Mcgee",
//       requireSponsorSMEReview: false,
//       requireSponsorQAReview: false,
//       impactOnProduct: "YES",
//       exceptionSeverity: "HIGH",
//       exceptionStatus: "Open",
//     },
//   ],
// };

const ExceptionStepper = (props) => {
  const { data } = props;
  const classes = useStyles();
  const [error, setError] = useState(false);


    const Row = ({ exceptionRow }) => {
    const [openException, setOpenException] = useState(false);

    return (
      <>
        <TableRow style={{backgroundColor:'#ffffff'}}>
          {/* <TableCell>
            <IconButton onClick={() => setOpenException(!openException)}>
              {openException ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell> */}
          <TableCell align="right">{presentFormatedData(exceptionRow.exceptionID)}</TableCell>
          <TableCell align="left" style={{width:'300px'}}>{presentFormatedData(exceptionRow.exceptionDescription)}</TableCell>
          <TableCell align="left" style={{whiteSpace:'nowrap'}}>
            {exceptionRow?.creationDate ? moment(exceptionRow.creationDate).format("DD-MMM-YYYY").toUpperCase(): '-NA-'}
          </TableCell>
          <TableCell align="center">
            <Checkbox
              checked={exceptionRow.requireSponsorSMEReview}
              disabled
              classes={{ root: classes.orangeCheckbox }}
            />
          </TableCell>
          <TableCell align="center">
            <Checkbox
              checked={exceptionRow.requireSponsorQAReview}
              disabled
              classes={{ root: classes.orangeCheckbox }}
            />
          </TableCell>
          <TableCell align="left">{presentFormatedData(exceptionRow.impactOnProduct)}</TableCell>
          <TableCell align="left">{presentFormatedData(exceptionRow.exceptionSeverity)}</TableCell>
        </TableRow>

        {openException && (
            <ExceptionDocuments
              open={openException}
            exceptionRow={exceptionRow}
            batchData={data}
            />
          )}
      </>
    );
  };

    return (
        <Box p={2} border={1} borderColor="grey.300"  style={{ backgroundColor: '#f9f9f9',marginTop:'2rem' }}>
    <TableRow >
      <TableCell colSpan={12} style={{ margin: "0px", padding:'3rem', border:'none' }}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell align="left" className={classes.tableHeadCell}>
                      Plant ID
                    </TableCell>
                    <TableCell align="left" className={classes.tableHeadCell}>
                      GMP Batch
                    </TableCell>
                    <TableCell align="left" className={classes.tableHeadCell}>
                      Batch Number
                    </TableCell>
                    <TableCell align="left" className={classes.tableHeadCell}>
                    MBR number
                    </TableCell>
                    <TableCell align="left" className={classes.tableHeadCell}>
                      Start Date
                    </TableCell>
                    <TableCell align="left" className={classes.tableHeadCell}>
                      End Date (expected)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell align="left" className={classes.tableCell}>
                      {presentFormatedData(data.plantID)}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {presentFormatedData(data.gmpBatchNumber)}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {presentFormatedData(data.batchNumber)}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {presentFormatedData(data.numberBMR)}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {data?.batchStartDate ? moment(data.batchStartDate).format(
                        "DD-MMM-YYYY"
                      ):'-NA-'}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {data.batchEndDate ? moment(data.batchEndDate).format("DD-MMM-YYYY").toUpperCase():'-NA-'}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>

              <Table style={{ border: "1px solid #ddd", marginTop: "1rem" }}>
                <TableHead>
                  <TableRow>
                    {/* <TableCell className={classes.tableHead}></TableCell> */}
                    <TableCell align="right" style={{whiteSpace:'nowrap'}} className={classes.tableHead}>
                      Exception ID
                    </TableCell>
                    <TableCell align="left" className={classes.tableHead}>
                      Exception Created
                    </TableCell>
                    <TableCell align="left" className={classes.tableHead}>
                      Created Date
                    </TableCell>
                    <TableCell align="center" className={classes.tableHead}>
                      Require Sponsor Review (SME)
                    </TableCell>
                    <TableCell align="center" className={classes.tableHead}>
                      Require Sponsor Review (QA)
                    </TableCell>
                    <TableCell align="left" className={classes.tableHead}>
                      Impact on Product
                    </TableCell>
                    <TableCell align="left" className={classes.tableHead}>
                      Exception Severity
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.reviewedExceptions ? data.reviewedExceptions.map((row, index) => (
                    <Row key={index} exceptionRow={row} />
                  )):(<TableRow>
                    <TableCell
                      colSpan={7}
                      align='center'
                    >
                      No Records Found
                    </TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
      </TableCell>
            </TableRow>
            </Box>
  );
};

export default ExceptionStepper;
